import React from 'react';
import Anchor from '../../objects/Anchor'
import {Icon} from "in-touch-icons";


const BlogsCard = (props) => {

    const {image, title, description, uid, category} = props.blogsData;
    const clever = props.clever === true ? 'clever' : '';
    let card;

    switch(props.length)
    {
        case 1: card = ''
            break;
        case 2: card = 'col-sm-6'
            break;
        case 3: card = 'col-xl-4'
            break;
        default: card = 'col-sm-6 col-xl-3'
    }

    const url = '/blog/'
    return (
        <div className={`col-12 ${card} base-card blog-card ${clever}`}>
            <Anchor path={`${url}${uid}`} anchorClass="card-inner" internal>
                <div className="theme-blog-head">
                    <div className="image"
                         style={{backgroundImage: `url(${image})`}}></div>
                </div>
                <div className="theme-blog-body">
                    <h3 className="heading-three">{title}</h3>
                    <p className="body-copy card-copy">{description}</p>
                    <div className="body-foot">
                        <Icon iconName='category'/>
                        <p className="body-copy">{category}</p>
                    </div>
                    <span className="theme-button">Read more</span>
                </div>
            </Anchor>
        </div>
    );
};

export default BlogsCard;


// WEBPACK FOOTER //
// src/client/components/dashboardNew/components/cards/BlogsCard.js